import React, { Component } from 'react';
import {
    Box,
    Container,
    Typography,
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    InputAdornment,
    Switch,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Avatar,
    Divider
} from '@mui/material';
import {
    Copy,
    ExternalLink,
    RefreshCw,
    Instagram,
    MessageCircle,
    Facebook,
    Send,
    Mail,
    CheckCircle2,
    Eye,
    Share2
} from 'lucide-react';

export default class MeuLinkPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customLink: '',
            shortLinkEnabled: true,
            publicLink: "https://fazpedido.app/",
            shortLink: "https://encurtar.me/PHKgtSE"
        };
    }

    handleCustomLinkChange = (e) => {
        this.setState({ customLink: e.target.value });
    };

    handleToggleShortLink = (e) => {
        this.setState({ shortLinkEnabled: e.target.checked });
    };

    render() {
        const { customLink, shortLinkEnabled, publicLink, shortLink } = this.state;

        return (
            <Box sx={{ bgcolor: '#f8f9fa', minHeight: '100vh', py: 0 }}>


                {/* HEADER */}
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={4} gap={2} flexWrap="wrap">
                    <Box>
                        <Typography variant="h5" fontWeight="700" color="#1a1a1a" gutterBottom>
                            Meu Link
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Compartilhe seu catálogo com um endereço fácil de lembrar
                        </Typography>
                    </Box>
                    <Box display="flex" gap={2}>
                        <Button
                            variant="outlined"
                            startIcon={<Eye size={18} />}
                            sx={{ borderColor: '#e0e0e0', color: '#1a1a1a', textTransform: 'none', borderRadius: 2 }}
                        >
                            Ver catálogo
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<Share2 size={18} />}
                            sx={{ bgcolor: '#8b5cf6', '&:hover': { bgcolor: '#7c3aed' }, textTransform: 'none', borderRadius: 2 }}
                        >
                            Compartilhar
                        </Button>
                    </Box>
                </Box>

                {/* CONTEÚDO PRINCIPAL */}
                <Grid container spacing={3}>

                    {/* COLUNA DA ESQUERDA: GERENCIADOR DE LINKS */}
                    <Grid size={{ xs: 6, md: 8 }}>
                        <Card sx={{ borderRadius: 3, boxShadow: '0px 4px 20px rgba(0,0,0,0.03)', p: 1 }}>
                            <CardContent>

                                {/* Seção 1: Link Público */}
                                <Typography variant="subtitle1" fontWeight="600" display="flex" alignItems="center" gap={1} mb={1}>
                                    <Box component="span" sx={{ color: '#8b5cf6', display: 'flex' }}><Share2 size={20} /></Box>
                                    Seu link de catálogo
                                </Typography>
                                <Typography variant="body2" color="text.secondary" mb={3}>
                                    Compartilhe seu catálogo com um endereço fácil de lembrar.
                                </Typography>

                                <Typography variant="caption" fontWeight="600" color="text.secondary" component="span" display="block" mb={1}>
                                    Link público
                                </Typography>
                                <Box display="flex" gap={1} mb={4}>
                                    <TextField
                                        fullWidth
                                        value={publicLink}
                                        InputProps={{ readOnly: true }}
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' } }}
                                    />
                                    <Button variant="outlined" startIcon={<Copy size={16} />} sx={{ textTransform: 'none', borderRadius: 2, color: '#1a1a1a', borderColor: '#e0e0e0' }}>
                                        Copiar
                                    </Button>
                                    <IconButton sx={{ border: '1px solid #e0e0e0', borderRadius: 2 }}>
                                        <ExternalLink size={18} />
                                    </IconButton>
                                </Box>

                                <Divider sx={{ my: 3 }} />

                                {/* Seção 2: Personalizar Link */}
                                <Typography variant="subtitle2" fontWeight="600" mb={0.5}>
                                    Personalize seu link
                                </Typography>
                                <Typography variant="body2" color="text.secondary" mb={2}>
                                    Escolha um identificador único para o catálogo.
                                </Typography>

                                <Box display="flex" gap={1} alignItems="center" mb={2}>
                                    <TextField
                                        fullWidth
                                        value={customLink}
                                        onChange={this.handleCustomLinkChange}
                                        size="small"
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">fazpedido.app/</InputAdornment>,
                                        }}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                    />
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
                                    <Typography variant="body2" color="#8b5cf6" display="flex" alignItems="center" gap={0.5} fontSize="0.85rem">
                                        <CheckCircle2 size={16} /> Esse é o link atual do seu catálogo.
                                    </Typography>
                                    <Button variant="contained" disabled sx={{ textTransform: 'none', borderRadius: 5, bgcolor: '#c0a5ff', color: '#fff' }}>
                                        Salvar
                                    </Button>
                                </Box>

                                <Divider sx={{ my: 3 }} />

                                {/* Seção 3: Link Encurtado */}
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                    <Box>
                                        <Typography variant="subtitle2" fontWeight="600">
                                            Link encurtado
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Endereço curto para redes sociais e impressos.
                                        </Typography>
                                    </Box>
                                    <Switch
                                        checked={shortLinkEnabled}
                                        onChange={this.handleToggleShortLink}
                                        color="secondary"
                                    />
                                </Box>

                                {shortLinkEnabled && (
                                    <Box display="flex" gap={1} mt={2}>
                                        <TextField
                                            fullWidth
                                            value={shortLink}
                                            InputProps={{ readOnly: true }}
                                            size="small"
                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' } }}
                                        />
                                        <Button variant="outlined" startIcon={<Copy size={16} />} sx={{ textTransform: 'none', borderRadius: 2, color: '#1a1a1a', borderColor: '#e0e0e0' }}>
                                            Copiar
                                        </Button>
                                        <IconButton sx={{ border: '1px solid #e0e0e0', borderRadius: 2 }}>
                                            <RefreshCw size={18} />
                                        </IconButton>
                                    </Box>
                                )}

                            </CardContent>
                        </Card>
                    </Grid>

                    {/* COLUNA DA DIREITA: COMPARTILHAR E DICAS */}
                    <Grid item md={4.5} size={{ xs: 6, md: 4 }} container spacing={3} direction="column">

                        {/* Card Redes Sociais */}
                        <Grid item>
                            <Card sx={{ borderRadius: 3, boxShadow: '0px 4px 20px rgba(0,0,0,0.03)' }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Typography variant="subtitle1" fontWeight="600" mb={2}>
                                        Compartilhar nas redes
                                    </Typography>

                                    <List disablePadding>
                                        {[
                                            { name: 'Instagram', desc: 'Adicionar na bio', icon: <Instagram size={20} color="#fff" />, bg: '#e1306c' },
                                            { name: 'WhatsApp', desc: 'Enviar para clientes', icon: <MessageCircle size={20} color="#fff" />, bg: '#25d366' },
                                            { name: 'Facebook', desc: 'Publicar no feed', icon: <Facebook size={20} color="#fff" />, bg: '#1877f2' },
                                            { name: 'Telegram', desc: 'Compartilhar em grupos', icon: <Send size={20} color="#fff" />, bg: '#0088cc' },
                                            { name: 'E-mail', desc: 'Enviar por e-mail', icon: <Mail size={20} color="#fff" />, bg: '#f59e0b' },
                                        ].map((item, index) => (
                                            <ListItem key={index} disableGutters sx={{ py: 1.5, cursor: 'pointer', '&:hover': { opacity: 0.8 } }}>
                                                <ListItemAvatar>
                                                    <Avatar sx={{ bgcolor: item.bg, width: 40, height: 40, borderRadius: 2.5 }}>
                                                        {item.icon}
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={<Typography variant="body2" fontWeight="600">{item.name}</Typography>}
                                                    secondary={<Typography variant="caption" color="text.secondary">{item.desc}</Typography>}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Card Dicas */}
                        <Grid item>
                            <Card sx={{ borderRadius: 3, boxShadow: '0px 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f0f0f0' }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Typography variant="subtitle1" fontWeight="600" mb={2}>
                                        Dicas para vender mais
                                    </Typography>

                                    <List disablePadding>
                                        {[
                                            { title: 'Adicione na bio do Instagram', desc: 'Seus seguidores veem todos os produtos' },
                                            { title: 'Compartilhe nos Stories', desc: 'Use o link para aumentar o alcance' },
                                        ].map((tip, index) => (
                                            <ListItem key={index} disableGutters sx={{ alignItems: 'flex-start', py: 1 }}>
                                                <Box component="span" sx={{ color: '#8b5cf6', mr: 1.5, mt: 0.3 }}>
                                                    <CheckCircle2 size={18} />
                                                </Box>
                                                <ListItemText
                                                    primary={<Typography variant="body2" fontWeight="600">{tip.title}</Typography>}
                                                    secondary={<Typography variant="caption" color="text.secondary">{tip.desc}</Typography>}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        </Grid>

                    </Grid>

                </Grid>

            </Box>
        );
    }
}